import { OnInit } from '@angular/core';
import { PriceUtils } from '../utils/price/price.utils';
import { LanguageService } from '../../services/language/language.service';
import { ProductTypeRenditionEnum } from '../../constants/renditions/product-type-rendition.constants';
var PriceDetailComponent = /** @class */ (function () {
    function PriceDetailComponent(languageService) {
        this.languageService = languageService;
        this.defaultRendition = ProductTypeRenditionEnum.default;
        this.StreamingBundleProductTypeRendition = ProductTypeRenditionEnum.streamingBundle;
    }
    Object.defineProperty(PriceDetailComponent.prototype, "priceDetail", {
        get: function () {
            return this._priceDetail;
        },
        set: function (value) {
            this._priceDetail = value;
        },
        enumerable: true,
        configurable: true
    });
    PriceDetailComponent.prototype.ngOnInit = function () {
        this._hasPromo = this._priceDetail && this._priceDetail.hasPromo();
    };
    Object.defineProperty(PriceDetailComponent.prototype, "hasPromo", {
        get: function () {
            return this._hasPromo;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PriceDetailComponent.prototype, "promoLabel", {
        get: function () {
            return this._priceDetail ? this._priceDetail.promoLabel : undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PriceDetailComponent.prototype, "promoDuration", {
        get: function () {
            return this._priceDetail ? this._priceDetail.promoDuration : undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PriceDetailComponent.prototype, "textIntegerPart", {
        get: function () {
            return this._priceDetail ? this._priceDetail.price.integerPart() : undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PriceDetailComponent.prototype, "textDecimalPart", {
        get: function () {
            return this.getTextDecimalPart(this._priceDetail ? this._priceDetail.price.decimalPart() : undefined);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PriceDetailComponent.prototype, "promoTextDecimalPart", {
        get: function () {
            return this.getTextDecimalPart(this._priceDetail ? this._priceDetail.promoPrice.decimalPart() : undefined);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PriceDetailComponent.prototype, "promoTextIntegerPrice", {
        get: function () {
            return this._priceDetail ? this._priceDetail.promoPrice.integerPart() : undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PriceDetailComponent.prototype, "getCurrentLang", {
        get: function () {
            return this.languageService.getCurrentLanguage().toLowerCase();
        },
        enumerable: true,
        configurable: true
    });
    PriceDetailComponent.prototype.getTextDecimalPart = function (price) {
        return PriceUtils.prefixDecimalPart(price, this.getCurrentLang);
    };
    return PriceDetailComponent;
}());
export { PriceDetailComponent };
